module.exports = __webpack_public_path__ + "img/theCover_08.13d55ff5.jpg";